import { m8API } from 'services/production/m8';
import { normalizeBillsTableSortableField } from 'services/production/utils/normalizeBillsTableSortableField';
import { GetBillsPageDataService } from 'types/services';
import { normalizeM8DebitDTO } from 'services/production/utils/normalizeM8Debit';

export const getBillsPageData: GetBillsPageDataService = async (params) => {
  const order = (() => {
    if (params.sorting.field === 'status') {
      return params.sorting.ascending ? 'DESC' : 'ASC';
    } else {
      return params.sorting.ascending ? 'ASC' : 'DESC';
    }
  })();

  const m8PagedResponse = await m8API.admin.getDebits({
    page: params.page - 1,
    size: params.pageSize,
    sort: normalizeBillsTableSortableField(
      params.sorting.field
    ).toM8BillRowSortableField(),
    order,
    startWith: params.searchBy || '',
  });

  if (m8PagedResponse) {
    return {
      totalPagesCount: m8PagedResponse.totalPages,
      bills: m8PagedResponse.content.map((m8Debit) =>
        normalizeM8DebitDTO(m8Debit).toBill()
      ),
    };
  }

  return {
    totalPagesCount: 0,
    bills: [],
  };
};
